import React, { useState } from 'react'
import uniqueId from 'lodash/uniqueId'
import '../../assets/css/components/Inputs/InputRadio.css'

const InputRadio: React.FC<InputRadioProps> = ({
  label,
  register,
  error,
  rules,
  classes,
  options,
  getValue,
  name,
  labelClasses,
  optionClasses,
  containerClasses,
  innerProps,
}) => {
  const randomId = uniqueId('label-')
  const [selected, setSelected] = useState<any>(options[0].value)

  return (
    <div className="text-center">
      <label
        htmlFor={randomId}
        className={`font-medium text-primary-900 text-xs dark:text-white ${labelClasses}`}
      >
        {label}
      </label>
      <div className="flex flex-row justify-around items-center pt-2">
        {options.map((o, key) => (
          <label
            key={key}
            className={`text-xs font-semibold text-primary-900 input-container ${optionClasses}`}
          >
            {o.name}
            <input
              id={o.name}
              name={name}
              type="radio"
              ref={register ? register(rules) : undefined}
              checked={o.value === selected}
              value={o.value}
              onChange={() => {
                setSelected(o.value)
                options = options.map((op) => ({
                  ...op,
                  selected: o.value === op.value,
                }))
                if (getValue) getValue(o.value)
              }}
              {...innerProps}
            />
            <span className="checkmark"></span>
          </label>
        ))}
      </div>
    </div>
  )
}

export default InputRadio

type InnerProps = JSX.IntrinsicElements['input']

interface InputRadioProps {
  label?: string
  classes?: string
  options: Array<OptionProps>
  labelClasses?: string
  optionClasses?: string
  containerClasses?: string
  innerProps?: InnerProps
  getValue?: Function
  [key: string]: any
}

interface OptionProps {
  name: string
  value: any
  selected: boolean
}
